import { CUSTOM_TYPE_NAME } from '../../../GlobalCopilot/constants';
import { Mention } from './MentionsNode/MentionPill';

const ANSWER_NOT_FOUND_POST_PROMPT_SUFFIX =
  ' Do you want to post it on the group chat?';

export const trimAnswerNotFoundPostPrompt = (
  text: string,
  meta?: Record<string, unknown>
): string => {
  if (
    meta &&
    (meta.type as string) === CUSTOM_TYPE_NAME.BUYER_COPILOT_ANSWER_NOT_FOUND &&
    text.endsWith(ANSWER_NOT_FOUND_POST_PROMPT_SUFFIX)
  ) {
    return text.slice(0, -ANSWER_NOT_FOUND_POST_PROMPT_SUFFIX.length);
  }
  return text;
};

/** Matches @@mention:ID@@ or @@mentions:ID@@ in message text (tagging). */
const MENTION_PLACEHOLDER_REGEX = /@@mention[s]?:([^@]+)@@/g;

/**
 * Replaces placeholder mention tokens in text with @value using meta.mentions.
 * Keeps each substituted tag as one piece (spaces in value preserved).
 */
export const substituteMentions = (
  text: string,
  meta: Record<string, unknown> | undefined
): string => {
  if (!text || !meta || !Array.isArray(meta.mentions)) {
    return text;
  }
  const mentions = meta.mentions as Mention[];
  const idToValue = mentions.reduce<Map<string, string>>((acc, m) => {
    const { id, uuid, value } = m;
    const key = (id ?? uuid)?.trim();
    if (key != null && typeof value === 'string') {
      acc.set(key, value);
    }
    return acc;
  }, new Map());
  if (idToValue.size === 0) {
    return text;
  }
  return text.replace(MENTION_PLACEHOLDER_REGEX, (_, id: string) => {
    const value = idToValue.get(id.trim());
    return value != null ? `@${value}` : `@@mention:${id}@@`;
  });
};
